import {
    useState,
} from 'react';

import {
    useInterval,
} from 'tools/hooks';

import {
    TIMER_SECONDS,
} from '../constants';

const SECONDS_MS = 1000;

export function useCurrentSeconds(isPending: boolean): number {
    const [currentSeconds, setCurrentSeconds] = useState(TIMER_SECONDS);

    useInterval(() => {
        if (isPending) {
            return;
        }

        setCurrentSeconds((prev) => Math.max(prev - 1, 0));
    }, SECONDS_MS, [isPending]);

    return currentSeconds;
}
